function required(key, defaultValue) {
  const value = process.env[key] || defaultValue;
  if (!value) {
    throw new Error(`Key ${key} is undefined`);
  }
  return value
}

export const configEnv = {
  nodeEnv: required('NODE_ENV'),
  phase: required('VUE_APP_PHASE'),
  api: {
    url: required('VUE_APP_API_URL'),
    authUrl: required('VUE_APP_API_AUTH_URL'),
  },
}
